import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { Reactions } from '@lumapps/reactions-core/components/Reactions';
import { Link as RouterLink } from '@lumapps/router';

import { useBlockVideoContext } from '../BlockVideoContext';
import { CLASSNAME as BLOCK_VIDEO_CLASSNAME } from '../constants';

export const CLASSNAME = `${BLOCK_VIDEO_CLASSNAME}-comments`;

type CommentsButtonProps = {
    to?: React.ComponentProps<typeof RouterLink>['to'];
};

/**
 * Displays the comments icon of a video.
 */
export const CommentsButton = ({ to }: CommentsButtonProps) => {
    const { get } = useDataAttributes(CLASSNAME);

    const { video, canDisplay, theme } = useBlockVideoContext();

    if (!video) {
        return null;
    }

    if (!canDisplay('REACTIONS')) {
        return null;
    }

    return (
        <Reactions.Comment
            commentCount={video.commentCount}
            linkAs={RouterLink}
            to={to}
            theme={theme}
            {...get({ element: 'button', action: 'comments' })}
        />
    );
};
